import ko from "knockout";
import $ from "jquery";
import "jquery-ui/ui/widgets/accordion";
import register from "flow/knockout/register";

register.registerKnockoutBinding("jqAccordion", {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        const options = valueAccessor();

        return ko.bindingHandlers.foreach.init(
            element,
            function () {
                return options.list;
            },
            allBindingsAccessor,
            viewModel,
            bindingContext
        );
    },
    update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        const options = valueAccessor();
        options.list(); //Needs to access list for ko to understand that it should update

        const accordionOptions = $.extend(
            {
                active: "none",
                heightStyle: "content",
                collapsible: true,
                beforeActivate: options.onAccordionToggle
            },
            options
        );

        const result = ko.bindingHandlers.foreach.update(
            element,
            function () {
                return options.list;
            },
            allBindingsAccessor,
            viewModel,
            bindingContext
        );

        if ($(element).data("accordion")) {
            $(element).accordion("destroy");
        }

        $(element).accordion(accordionOptions);

        return result;
    }
});

register.registerKnockoutBinding("simpleJqAccordion", {
    init: function (element, valueAccessor) {
        const options = valueAccessor();

        const accordionOptions = $.extend(
            {
                active: "none",
                heightStyle: "content",
                collapsible: true,
                beforeActivate: options.onAccordionToggle
            },
            options
        );

        if ($(element).data("accordion")) {
            $(element).accordion("destroy");
        }

        $(element).accordion(accordionOptions);
    }
});
